<template>
  <div>
    <nav-bar />
    <Hero />
    <div class="container" id="content__container">
      <div class="text-center">
        <PageHeader :title="'Our Goodbye'"></PageHeader>
        <IntroRow />
      </div>      
    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Hero from './components/structure/Hero.vue'
import IntroRow from './components/structure/Intro.vue'
import NavBar from './components/navbar/NavBar.vue'
import Footer from './components/structure/Footer.vue'
import PageHeader from './components/structure/PageHeader.vue'

export default {
  name: 'App',
  components: {
    'nav-bar': NavBar,
    Hero,
    IntroRow,
    Footer,
    PageHeader
  }
}
</script>

<style>
  #content__container {
    padding-bottom: 260px;
    padding-top: 0px;
  }
</style>
